import { isSessionExpiredError } from './errors.js';
let signingOut = false;
/**
 * Leaves the SPA rather than navigating through the router so the in-memory
 * query cache is dropped along with the cookies.
 *
 * Takes a single argument so it can be handed straight to react-query's
 * `QueryCache`/`MutationCache` `onError`, which calls it with extra arguments.
 * Everything that is not a session expiry is left alone.
 */
export const handleSessionExpired = (error) => {
    if (!isSessionExpiredError(error) || typeof window === 'undefined') {
        return;
    }
    if (signingOut) {
        return;
    }
    signingOut = true;
    window.location.assign('/logout');
};
//# sourceMappingURL=session-expiry.js.map